import { autoinject } from 'aurelia-framework';
import { PayrazrService } from '../../services/payrazr';
import { Router } from 'aurelia-router';

@autoinject
export class CancelInstallments {
	isSubmitting = false;
	planId: string;

	constructor(
		private payrazrService: PayrazrService,
		private router: Router
	) { }

	activate(params) {
		this.payrazrService.getPaymentPlanByCustomerAccountId(params.id)
			.then(response => {
				this.planId = response.id;
			})
			.catch(reason => {
				alert('An error occurred.');
				this.back();
			});
	}

	back() {
		this.router.navigateBack();
	}

	submit() {
		this.isSubmitting = true;
		this.payrazrService.cancelPaymentPlan(this.planId).then(
			(result) => {
				this.isSubmitting = false;
				this.router.navigateToRoute('secure');
			},
			(error) => {
				this.isSubmitting = false;
			}
		);
	}
}